export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatINR = (amount) => {
  const n = Number(amount) || 0;
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

// Maps a workflow status to a badge CSS class (defined in App.css).
export const statusBadgeClass = (status) => {
  switch (status) {
    case 'approved':
    case 'accepted':
    case 'paid':
    case 'verified':
    case 'valid':
    case 'active':
    case 'excellent':
      return 'badge-success';
    case 'rejected':
    case 'flagged':
    case 'suspended':
    case 'poor':
      return 'badge-danger';
    case 'pending':
    case 'requested':
    case 'submitted':
    case 'average':
      return 'badge-warning';
    case 'processing':
    case 'good':
      return 'badge-info';
    default:
      return 'badge-neutral';
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};
